// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAppNotificationDto
 */
export interface IAppNotificationDto {
    /**
     * 
     * @type {number}
     * @memberof IAppNotificationDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAppNotificationDto
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof IAppNotificationDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof IAppNotificationDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IAppNotificationDto
     */
    type?: IAppNotificationDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAppNotificationDto
     */
    status?: IAppNotificationDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IAppNotificationDto
     */
    priority?: IAppNotificationDtoPriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof IAppNotificationDto
     */
    page?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof IAppNotificationDto
     */
    template_variables_values?: { [key: string]: string; };
}

/**
* @export
* @enum {string}
*/
export enum IAppNotificationDtoTypeEnum {
    SIGN_UP = 'SIGN_UP',
    FORGOT_PASSWORD = 'FORGOT_PASSWORD',
    WELCOME_ABOARD = 'WELCOME_ABOARD',
    BENEFICIARY_CHANGES = 'BENEFICIARY_CHANGES',
    TRANSFER_OF_ASSETS_UPDATES = 'TRANSFER_OF_ASSETS_UPDATES',
    CARD_STATUS_CHANGE = 'CARD_STATUS_CHANGE',
    PROFILE_UPDATE = 'PROFILE_UPDATE',
    PAYMENT_METHOD_UPDATE = 'PAYMENT_METHOD_UPDATE',
    CLAIM_ACTIVITY_ACTION = 'CLAIM_ACTIVITY_ACTION',
    CARD_TRANSACTION_ALERT = 'CARD_TRANSACTION_ALERT',
    PASSWORD_CHANGED = 'PASSWORD_CHANGED',
    CLAIM_ACTIVITY_NO_ACTION = 'CLAIM_ACTIVITY_NO_ACTION',
    CONTRIBUTION_INVOICE_READY = 'CONTRIBUTION_INVOICE_READY',
    REPLENISHMENT_INVOICE_READY = 'REPLENISHMENT_INVOICE_READY',
    CARD_ACTIVATION_REMINDER = 'CARD_ACTIVATION_REMINDER',
    TRIGGER_MET = 'TRIGGER_MET',
    ORPHAN = 'ORPHAN',
    CLOSED_ACCOUNT = 'CLOSED_ACCOUNT',
    ACH_REJECTED = 'ACH_REJECTED',
    PRE_FUND = 'PRE_FUND',
    INDIVIDUAL_CONTRIBUTION = 'INDIVIDUAL_CONTRIBUTION',
    FILE_PROCESSED_SUCCESSFULLY = 'FILE_PROCESSED_SUCCESSFULLY',
    STATEMENT_GENERATED = 'STATEMENT_GENERATED',
    CIP_FAILED = 'CIP_FAILED',
    INDIVIDUAL_CONTRIBUTION_REMINDER = 'INDIVIDUAL_CONTRIBUTION_REMINDER',
    CARD_DECLINE_ACTIVATION_NEEDED = 'CARD_DECLINE_ACTIVATION_NEEDED',
    OUTSTANDING_CHECK_REMINDER = 'OUTSTANDING_CHECK_REMINDER',
    CARD_DECLINE_LOST_STOLEN = 'CARD_DECLINE_LOST_STOLEN',
    CARD_DECLINE_LOCKED_FROZEN = 'CARD_DECLINE_LOCKED_FROZEN',
    CHECK_VOID = 'CHECK_VOID',
    AUTOMATIC_INVESTMENTS = 'AUTOMATIC_INVESTMENTS',
    CARD_DECLINE_WALMART = 'CARD_DECLINE_WALMART',
    CARD_DECLINE_NON_HEALTHCARE = 'CARD_DECLINE_NON_HEALTHCARE',
    REIMBURSEMENT_FAILED = 'REIMBURSEMENT_FAILED',
    CARD_DECLINE_CVS_NOT_ALLOWED = 'CARD_DECLINE_CVS_NOT_ALLOWED',
    CARD_DECLINE_NOT_ENOUGH_BALANCE = 'CARD_DECLINE_NOT_ENOUGH_BALANCE',
    CARD_DECLINE_PLAN_NOT_STARTED = 'CARD_DECLINE_PLAN_NOT_STARTED',
    CHECK_EXPIRED = 'CHECK_EXPIRED',
    CARD_DECLINE_NO_AVAILABLE_BALANCE = 'CARD_DECLINE_NO_AVAILABLE_BALANCE',
    CARD_DECLINE_GENERIC = 'CARD_DECLINE_GENERIC',
    INDIVIDUAL_CONTRIBUTION_FAILED = 'INDIVIDUAL_CONTRIBUTION_FAILED',
    CARD_DECLINE_PAST_PLAN_END_DATE = 'CARD_DECLINE_PAST_PLAN_END_DATE',
    ISO_NEEDS_HELP = 'ISO_NEEDS_HELP',
    CARD_DECLINE_PIN_INVALID = 'CARD_DECLINE_PIN_INVALID',
    ISO_ORG_LOCKED = 'ISO_ORG_LOCKED',
    ISO_OVERLIMIT = 'ISO_OVERLIMIT',
    PHONE_VERIFICATION = 'PHONE_VERIFICATION',
    MFA_SMS = 'MFA_SMS',
    MFA_EMAIL = 'MFA_EMAIL',
    CARD_DECLINE_NOT_ALLOWED_SERVICE_FOR_PLAN = 'CARD_DECLINE_NOT_ALLOWED_SERVICE_FOR_PLAN',
    EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
    FORGOT_USERNAME = 'FORGOT_USERNAME',
    CARD_DECLINE_PEND_CONTRIBUTIONS = 'CARD_DECLINE_PEND_CONTRIBUTIONS',
    CARD_DECLINE_PEND_CONTRIBUTIONS_AND_CIP = 'CARD_DECLINE_PEND_CONTRIBUTIONS_AND_CIP',
    COMPLETE_SETUP = 'COMPLETE_SETUP',
    EMPLOYEE_ELECTION_NEEDED = 'EMPLOYEE_ELECTION_NEEDED',
    END_PLAN_YEAR_INITIAL = 'END_PLAN_YEAR_INITIAL',
    LOCKBOX_INBOUND_TOA_PROCESSED = 'LOCKBOX_INBOUND_TOA_PROCESSED',
    CONTACT_INFO_UPDATED = 'CONTACT_INFO_UPDATED',
    SCHEDULED_CONTRIBUTION = 'SCHEDULED_CONTRIBUTION',
    END_PLAN_YEAR_REMINDER = 'END_PLAN_YEAR_REMINDER',
    CLAIM_OFFSET = 'CLAIM_OFFSET',
    LOCKBOX_OUTBOUND_TOA_PENDING_INVESTMENTS = 'LOCKBOX_OUTBOUND_TOA_PENDING_INVESTMENTS',
    LOCKBOX_OUTBOUND_TOA_PROCESSED = 'LOCKBOX_OUTBOUND_TOA_PROCESSED',
    NEW_BANK_ACCOUNT_ADDED = 'NEW_BANK_ACCOUNT_ADDED',
    SMS_CONTACT_VERIFICATION = 'SMS_CONTACT_VERIFICATION',
    EMAIL_CONTACT_VERIFICATION = 'EMAIL_CONTACT_VERIFICATION',
    BANK_ACCOUNT_VERIFICATION_STATUS_CHANGE = 'BANK_ACCOUNT_VERIFICATION_STATUS_CHANGE',
    PERSON_ACCOUNTS_LINKED = 'PERSON_ACCOUNTS_LINKED',
    TAX_FORMS = 'TAX_FORMS',
    PRE_FUND_PUSH = 'PRE_FUND_PUSH',
    CARD_DECLINE_DATA_ENTERED_INCORRECTLY = 'CARD_DECLINE_DATA_ENTERED_INCORRECTLY',
    DUPLICATE_FILE_FOUND = 'DUPLICATE_FILE_FOUND',
    INTERNAL_FEEDBACK = 'INTERNAL_FEEDBACK',
    BENEFICIARY_UPDATE = 'BENEFICIARY_UPDATE',
    RENEWAL_INITIAL = 'RENEWAL_INITIAL',
    CIP_FAILED_CLOSED_ACCOUNT = 'CIP_FAILED_CLOSED_ACCOUNT',
    CARD_DECLINE_TEMPORARY_BLOCKED_MERCHANT = 'CARD_DECLINE_TEMPORARY_BLOCKED_MERCHANT',
    CARD_DECLINE_PERMANENTLY_BLOCKED_MERCHANT = 'CARD_DECLINE_PERMANENTLY_BLOCKED_MERCHANT',
    RENEWAL_REQUEST = 'RENEWAL_REQUEST',
    CARD_DECLINE_TERMINATED_EMPLOYEE = 'CARD_DECLINE_TERMINATED_EMPLOYEE',
    CARD_DECLINE_TERMINATED_EMPLOYER = 'CARD_DECLINE_TERMINATED_EMPLOYER',
    CARD_DECLINE_ORPHANED_EMPLOYEE = 'CARD_DECLINE_ORPHANED_EMPLOYEE',
    RENEWAL_REMINDER = 'RENEWAL_REMINDER',
    SCHEDULED_REPORT = 'SCHEDULED_REPORT',
    PUSH_PROVISIONING = 'PUSH_PROVISIONING',
    EXCESS_CONTRIBUTION = 'EXCESS_CONTRIBUTION',
    EOY_SHORTAGE_PULL = 'EOY_SHORTAGE_PULL',
    EOY_SHORTAGE_PUSH = 'EOY_SHORTAGE_PUSH',
    RETURN_UNUSED_FUNDS = 'RETURN_UNUSED_FUNDS',
    CONTRIBUTION_RETURN_PUSH_PULL = 'CONTRIBUTION_RETURN_PUSH_PULL',
    COMBINE_HSA = 'COMBINE_HSA',
    AUTHORIZED_USER = 'AUTHORIZED_USER',
    RETURNED_MAIL = 'RETURNED_MAIL',
    BAF_COLLECT_PULL = 'BAF_COLLECT_PULL',
    BAF_COLLECT_PUSH = 'BAF_COLLECT_PUSH',
    BAF_RETURN_PULL_PUSH = 'BAF_RETURN_PULL_PUSH',
    CARD_DECLINE_LOCKED_CARD_PURSE = 'CARD_DECLINE_LOCKED_CARD_PURSE',
    RETURNED_CHECK = 'RETURNED_CHECK'
}
/**
* @export
* @enum {string}
*/
export enum IAppNotificationDtoStatusEnum {
    NOT_SENT = 'NOT_SENT',
    SENT = 'SENT',
    CANCELLED = 'CANCELLED',
    ARCHIVED = 'ARCHIVED',
    READ = 'READ',
    RESENT = 'RESENT',
    SENDING = 'SENDING',
    BOUNCED = 'BOUNCED',
    DELIVERED = 'DELIVERED',
    OPENED = 'OPENED',
    REPORTED_AS_SPAM = 'REPORTED_AS_SPAM',
    UNSUBSCRIBED = 'UNSUBSCRIBED',
    RETURNED = 'RETURNED',
    PENDING_ADDRESS = 'PENDING_ADDRESS'
}
/**
* @export
* @enum {string}
*/
export enum IAppNotificationDtoPriorityEnum {
    IMPORTANT = 'IMPORTANT',
    NEED_HELP = 'NEED_HELP',
    INFO = 'INFO'
}


/**
 * Check if a given object implements the IAppNotificationDto interface.
 */
export function instanceOfIAppNotificationDto(value: object): value is IAppNotificationDto {
    return true;
}

export function IAppNotificationDtoFromJSON(json: any): IAppNotificationDto {
    return IAppNotificationDtoFromJSONTyped(json, false);
}

export function IAppNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAppNotificationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created_at': json['createdAt'] == null ? undefined : json['createdAt'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'] == null ? undefined : json['status'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'page': json['page'] == null ? undefined : json['page'],
        'template_variables_values': json['templateVariablesValues'] == null ? undefined : json['templateVariablesValues'],
    };
}

export function IAppNotificationDtoToJSON(json: any): IAppNotificationDto {
    return IAppNotificationDtoToJSONTyped(json, false);
}

export function IAppNotificationDtoToJSONTyped(value?: IAppNotificationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['created_at'],
        'title': value['title'],
        'description': value['description'],
        'type': value['type'],
        'status': value['status'],
        'priority': value['priority'],
        'page': value['page'],
        'templateVariablesValues': value['template_variables_values'],
    };
}

